import { useTranslation } from 'react-i18next'

import { MagnifyingGlassIcon } from '@phosphor-icons/react'

import { Button, CardTitle, Drawer, Loading, SearchInput, Text } from '@reveni-io/reveni-ui'

import Order from './Order/Order'
import * as Styles from './styles'

const NewRMADrawer = ({
  show,
  onClose,
  searchValue,
  onChangeSearchValue,
  onSearchOrders,
  searchingOrders,
  orders,
  onViewOrder,
}) => {
  const { t } = useTranslation()

  const onSubmit = e => {
    e.preventDefault()
    onSearchOrders()
  }

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Nuevo RMA')}</CardTitle>
      <Styles.Container>
        <Text type="titleS">{t('Pedidos')}:</Text>
        <Text type="bodyMRegular">{t('Selecciona un pedido para iniciar el proceso')}:</Text>
        <Styles.Form onSubmit={onSubmit}>
          <SearchInput
            fullWidth
            placeholder={t('Num. pedido, email')}
            value={searchValue}
            onSearch={onChangeSearchValue}
            minCharsToTrigger={4}
            searchTimeout={0}
            onChangeValue={onChangeSearchValue}
          />
          <Button type="submit" disabled={searchingOrders} fullWidth>
            <MagnifyingGlassIcon size={24} />
            {t('Buscar pedidos')}
          </Button>
        </Styles.Form>
        {orders === null && !searchingOrders && (
          <Styles.StartSearchContainer>
            <img src="/logos/reveni_icon.svg" alt="Reveni Logo" width={100} />
            <Text type="titleM" color="#A1A1A1">
              {t('Introduce un número de pedido o una dirección de correo para comenzar la búsqueda')}
            </Text>
          </Styles.StartSearchContainer>
        )}
        {orders?.length === 0 && !searchingOrders && (
          <Styles.NoResultsFoundContainer>
            <img src="/icons/cross.png" />
            <Text type="titleM" color="#A1A1A1">
              {t('No hay resultados para esta búsqueda')}
            </Text>
          </Styles.NoResultsFoundContainer>
        )}
        <Loading show={searchingOrders} height="300px">
          {orders?.map(order => (
            <Order key={order.id} info={order} onViewOrder={onViewOrder} />
          ))}
        </Loading>
      </Styles.Container>
    </Drawer>
  )
}

export default NewRMADrawer
